'use client'

import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { ReactNode } from 'react'

import CustomersHero from '@/components/Hero/CustomersHero'
import LearnMoreTiles from '@/components/LearnMoreTiles'
import CustomersAnimation from '@/components/MovingChipAnimation/CustomersAnimation'
import RequestDemo from '@/components/RequestDemo'
import CustomersTab1 from '@/sections/CustomersTab1'
import CustomersTab2 from '@/sections/CustomersTab2'
import CustomersTab3 from '@/sections/CustomersTab3'
import FortoCustomerStoryWithPercentage from '@/sections/FortoCustomerStoryWithPercentage'
import PayhawkCaseStudyBox from '@/sections/PayhawkCaseStudyBox'
import { RenderOn } from '@/utills/DeviceUtils'

function Heading({ text }: { text: ReactNode }) {
    return (
        <>
            <RenderOn breakPoints={['md', 'lg', 'xl']}>
                <Text
                    sx={{
                        mb: 15,
                        textAlign: 'center',
                    }}
                    variant={`h4`}
                >
                    {text}
                </Text>
            </RenderOn>
            <RenderOn breakPoints={['xs', 'sm']}>
                <Text
                    sx={{
                        mb: 6,
                        textAlign: 'start',
                    }}
                    variant={`h5`}
                >
                    {' '}
                    {text}
                </Text>
            </RenderOn>
        </>
    )
}

export default function Customers() {
    return (
        <>
            <CustomersHero />
            <LearnMoreTiles
                tiles={[
                    {
                        title: <>Logistics</>,
                        scrollToSection: 'winning-more-deals',
                        icon: '/icons/icon-logistics.png',
                    },
                    {
                        title: 'Spend management',
                        scrollToSection: 'surging-ahead',
                        icon: '/icons/icon-fintech.png',
                    },
                    {
                        title: <>Carbon credits buyers</>,
                        scrollToSection: 'funding-climate-projects',
                        icon: '/icons/icon-climate-projects.png',
                    },
                ]}
            />
            <Box id={`winning-more-deals`}>
                <Heading
                    text={
                        <>
                            Winning more deals with <br />
                            end-to-end sustainable logistics
                        </>
                    }
                />
                <FortoCustomerStoryWithPercentage />
            </Box>
            <CustomersTab2 />
            <CustomersAnimation />
            <Box id={`surging-ahead`}>
                <Heading
                    text={
                        <>
                            Surging ahead in sustainable banking
                            <br />
                            with end-to-end climate action
                        </>
                    }
                />
                <CustomersTab3 />
            </Box>
            <PayhawkCaseStudyBox />
            <Box id={`funding-climate-projects`}>
                <Heading
                    text={
                        <>
                            Funding climate projects that deliver <br />
                            measurable impact and peace of mind
                        </>
                    }
                />
                <CustomersTab1 />
            </Box>
            <RequestDemo />
        </>
    )
}
